/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why are standup meetings timeboxed to around 10-15 minutes?`)
};

const es_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué las reuniones de pie se acotan a unos 10-15 minutos?`)
};

const de_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sind Standup-Meetings meist auf 10-15 Minuten begrenzt?`)
};

const nl_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom worden stand-up meetings getimeboxt tot ongeveer 10-15 minuten?`)
};

const fr_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les daily standups sont-ils limités à environ 10-15 minutes ?`)
};

const it_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché gli standup meeting sono delimitati a circa 10-15 minuti?`)
};

const pt_br2_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que as daily meetings costumam ter um limite de 10 a 15 minutos?`)
};

const pt_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as reuniões de ponto de situação são delimitadas a cerca de 10-15 minutos?`)
};

const ja_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜスタンドアップミーティングは10〜15分程度に区切られるのですか？`)
};

const zh_timer_u10m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么站会通常限制在10-15分钟左右？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_faq4_q", locale)
	if (locale === "en") return en_timer_u10m_faq4_q(inputs)
	if (locale === "es") return es_timer_u10m_faq4_q(inputs)
	if (locale === "de") return de_timer_u10m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u10m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u10m_faq4_q(inputs)
	if (locale === "it") return it_timer_u10m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u10m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u10m_faq4_q(inputs)
	return zh_timer_u10m_faq4_q(inputs)
};